import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { withTheme } from 'styled-components';
import LineHeightText from 'components/LineHeightText';
import { SearchableListContainer } from 'components/SearchableListContainer';
import { Table } from 'components/Table';
import { useGetRefundsByAccount } from '../Accounts/gql/queries/useGetRefundsByAccount';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

const Refunds = () => {
  const { id } = useParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const currentPage = parseInt(urlParams.get('page'));

  const { data, loading, error } = useGetRefundsByAccount({
    accountId: parseInt(id),
    limit: 15,
    page: currentPage ? String(currentPage) : '1',
  });

  const columns = [
    {
      label: 'Order #',
      key: 'id',
    },
    {
      label: 'Customer',
      key: 'user',
    },
    {
      label: 'Event',
      key: 'event',
    },
    {
      label: 'Date',
      key: 'date',
    },
    {
      label: 'Refund Total',
      key: 'total',
    },
    {
      label: 'Track Amount',
      key: 'track_amount',
    },
    {
      label: 'Fee Impact',
      key: 'fees',
    },
    {
      label: 'Created By',
      key: 'created_by',
    },
  ];

  function renderRows(refund) {
    const { user, purchase, date, total, track_amount, fees, createdBy } =
      refund;

    return {
      id: (
        <Link
          to={`/admin/transactions/detail/${purchase.id}`}
          style={{
            color: '#fa4616',
            textDecoration: 'none',
            fontWeight: '600',
          }}
          onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
          onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
        >
          {purchase?.id || 'N/A'}
        </Link>
      ),
      user: <LineHeightText>{user?.formatted_name || 'N/A'}</LineHeightText>,
      event: <LineHeightText>{purchase?.event?.name || 'N/A'}</LineHeightText>,
      date: <LineHeightText>{date ? date : 'N/A'}</LineHeightText>,
      total: (
        <LineHeightText>
          {total ? formatCurrency(total) : '0.00'}
        </LineHeightText>
      ),
      track_amount: (
        <LineHeightText>
          {track_amount ? formatCurrency(track_amount) : '0.00'}
        </LineHeightText>
      ),
      fees: (
        <LineHeightText>${fees ? formatCurrency(fees) : '0.00'}</LineHeightText>
      ),
      created_by: (
        <LineHeightText>{createdBy?.formatted_name || 'N/A'}</LineHeightText>
      ),
    };
  }

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading refunds</div>;

  return !data?.getRefundsByAccount ? (
    <div />
  ) : (
    <SearchableListContainer
      pageCount={data.getRefundsByAccount.count}
      paginated
      title="Refunds"
      noSearch={true}
    >
      <Table
        items={data.getRefundsByAccount.results}
        columns={columns}
        renderRows={renderRows}
      />
    </SearchableListContainer>
  );
};

export default withTheme(Refunds);
